"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseSize = exports.montserrat = void 0;
var montserrat = '\'Montserrat\', Arial, sans-serif';
exports.montserrat = montserrat;
var baseSize = '16px';
exports.baseSize = baseSize;